import { EmployeeHierarchyItemResponse, EmployeeHierarchyResponse } from '@/types/service-response'

export class EmployeeHierarchyList {
  private constructor (
    readonly id: number,
    readonly position: number,
    readonly name: string,
  ) {}

  public static createListFromResponse (data: EmployeeHierarchyResponse): Array<EmployeeHierarchyList> {

    return data.map((item: EmployeeHierarchyItemResponse, idx: number) => {
      return new EmployeeHierarchyList(
        item.ID,
        idx +1,
        item.employee_name,
      )
    })
  }

  public static updatePosition (data: Array<EmployeeHierarchyList>): Array<EmployeeHierarchyList> {
    return data.map((item: EmployeeHierarchyList, idx: number) => {
      return new EmployeeHierarchyList(
        item.id,
        idx + 1,
        item.name,
      )
    })
  }
}
